import { action, extendObservable } from 'mobx';
import { orderBy } from 'lodash';
import FetchService from '../../../core/services/FetchService';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import NotificationService from '../../../core/services/NotificationService';

class ModuleListService {
  fetch = new FetchService();
  submit = new FetchService();

  constructor(courseId) {
    extendObservable(this, {
      modules: [],
    });
    this.courseId = courseId;
  }

  load = action(() => {
    this.fetch
      .fetch({
        url: '/modules',
        query: {
          verbose: true,
          query: {
            course: this.courseId,
          },
        },
      })
      .then(() => {
        if (this.fetch.data) {
          this.modules = orderBy(this.fetch.data, ['course.name', 'group', 'order'], ['asc', 'asc', 'asc']);
        } else {
          this.modules = [];
        }
      });
  });

  handleRemove = action((module) => {
    ConfirmationDialogService.show(
      'Delete Module',
      `You are about to delete the module "${module.name}", Do you want to continue ?`,
      () => {
        this.submit
          .fetch({
            url: `/modules/${module.id}`,
            method: 'delete',
          })
          .then(() => {
            if (this.fetch.data) {
              NotificationService.addNotification(`Module ${module.name} deleted.`, 'success');
              this.load();
            }
            if (this.fetch.error) {
              NotificationService.addNotification(this.fetch.error, 'error');
            }
          });
      }
    );
  });

  handlePublish = (module) => {
    ConfirmationDialogService.show(
      `${module.name}`,
      'Would you like to publish this module? It will be showed to students.',
      () => {
        this.submit
          .fetch({
            url: `/modules/${module.id}/publish`,
            method: 'patch',
          })
          .then(() => {
            if (this.submit.data) {
              NotificationService.addNotification('Module published successfully.', 'success');
              this.load();
            }
            if (this.submit.error) {
              NotificationService.addNotification('Error publishing module.', 'error');
            }
          });
      }
    );
  };

  handleUnpublish = (module) => {
    ConfirmationDialogService.show(
      `${module.name}`,
      'Would you like to unpublished this module? It will no longer be showed to students.',
      () => {
        this.submit
          .fetch({
            url: `/modules/${module.id}/unpublish`,
            method: 'patch',
          })
          .then(() => {
            if (this.submit.data) {
              NotificationService.addNotification('Module unpublished successfully.', 'success');
              this.load();
            }
            if (this.submit.error) {
              NotificationService.addNotification('Error unpublishing module.', 'error');
            }
          });
      }
    );
  };
}

export default ModuleListService;
